export default class CurriculumNode {
  constructor(value, next) {
    this.value = value;
    this.next = next;
  }
}
